export const columnAmounts = {
  two: 2,
  four: 4,
};
